import { render, staticRenderFns } from "./ServiceQuotationViewItem.vue?vue&type=template&id=16f91d82&scoped=true&"
import script from "./ServiceQuotationViewItem.vue?vue&type=script&lang=js&"
export * from "./ServiceQuotationViewItem.vue?vue&type=script&lang=js&"
import style0 from "./ServiceQuotationViewItem.vue?vue&type=style&index=0&id=16f91d82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f91d82",
  null
  
)

export default component.exports